import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
// add filters
import filters from './global/filters/filters'
//materialdesignicons
import '@mdi/font/css/materialdesignicons.css'
//custom css
import './assets/css/variables.scss'
import './assets/css/custom.css'

//modules

import { registerModules } from "./register-modules";

import appview from "./modules/appview";
// plugins

import VueSweetalert2 from "./plugins/sweetalert";
// end plugins
//Vuetify
import Vuetify from 'vuetify/lib'
import 'vuetify/dist/vuetify.min.css'
const vuetifyOptions = {
  theme: {
      themes: {
          light: {
              primary: "#292961",
              secondary: "#3cbd9c",
              darkBlue: "#505D6F",
              grey: "#9AA1A9"
          }
      }
  },
}




registerModules({
  appview:appview,
});

Vue.config.productionTip = false
Vue.use(Vuetify)
new Vue({
  router,
  store,
  vuetify: new Vuetify(vuetifyOptions),
  VueSweetalert2,
  filters,
  render: h => h(App)
}).$mount("#app");
